import { render, staticRenderFns } from "./CurrentVisitList.vue?vue&type=template&id=d0c149e6"
import script from "./CurrentVisitList.vue?vue&type=script&lang=js"
export * from "./CurrentVisitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports